export default __webpack_public_path__ + "static/media/ss-1.b67adb7c.jpg";